"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineMainFrameNavigator = exports.MainFrameNavigator = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const lib_es2015_2 = require("@hodol/searchable-tree-menu/lib-es2015");
const TenantConstant = require("../tenant/constants");
const OauthClientConstant = require("../oauth-client/constants");
const ResourceOwnerConstant = require("../resource-owner/constants");
const MemberGroupConstant = require("../member-group/constants");
const MemberConstant = require("../member/constants");
const MemberPermissionConstant = require("../member-permission/constants");
class MainFrameNavigator extends HTMLElement {
    constructor() {
        super();
        this.router = (0, lib_es2015_1.useRouter)();
        const isMobile = window.matchMedia(`(max-width: 600px)`).matches;
        const menuCfg = {
            name: ``,
            children: [
                {
                    name: `Tenant`,
                    onMenuClick: () => {
                        this.router.push(`/web/${TenantConstant.routerPathGroup}/list?page_no=1&page_size=10&query=&id=`);
                        if (isMobile)
                            this.style.setProperty('display', 'none');
                    },
                },
                {
                    name: `Oauth Client`,
                    onMenuClick: () => {
                        this.router.push(`/web/${OauthClientConstant.routerPathGroup}/list?page_no=1&page_size=10&query=&tenant_pk=`);
                        if (isMobile)
                            this.style.setProperty('display', 'none');
                    },
                },
                {
                    name: `Resource Owner`,
                    onMenuClick: () => {
                        this.router.push(`/web/${ResourceOwnerConstant.routerPathGroup}/list?page_no=1&page_size=10&query=`);
                        if (isMobile)
                            this.style.setProperty('display', 'none');
                    },
                },
                {
                    name: `Member Group`,
                    onMenuClick: () => {
                        this.router.push(`/web/${MemberGroupConstant.routerPathGroup}/list?page_no=1&page_size=10&query=&oauth_client_pk=`);
                        if (isMobile)
                            this.style.setProperty('display', 'none');
                    },
                },
                {
                    name: `Member`,
                    onMenuClick: () => {
                        this.router.push(`/web/${MemberConstant.routerPathGroup}/list?page_no=1&page_size=10&query=&oauth_client_pk=&resource_owner_pk=&member_group_pks=`);
                        if (isMobile)
                            this.style.setProperty('display', 'none');
                    },
                },
                {
                    name: `Member Permission`,
                    onMenuClick: () => {
                        this.router.push(`/web/${MemberPermissionConstant.routerPathGroup}/list?page_no=1&page_size=10&query=&oauth_client_pk=`);
                        if (isMobile)
                            this.style.setProperty('display', 'none');
                    },
                },
            ],
            isFold: false,
        };
        const treeMenu = new lib_es2015_2.MenuNode(menuCfg, 0);
        this.appendChild(treeMenu);
        if (isMobile)
            this.style.setProperty('display', 'none');
    }
}
exports.MainFrameNavigator = MainFrameNavigator;
const defineMainFrameNavigator = (name) => {
    (0, lib_es2015_2.define)(`searchable-tree-menu`);
    (0, lib_es2015_1.defineIfUndefined)(name, MainFrameNavigator);
};
exports.defineMainFrameNavigator = defineMainFrameNavigator;
